<template>
  <v-container fluid :class="{'px-0': $vuetify.breakpoint. smAndDown}">
    <v-layout xs12>
      <v-flex sm12>
        <v-card class="mx-5: $vuetify.breakpoint. mdAndUp">
          <v-flex xs12>
            <v-textarea
              value="Результаты расчёта хэш-сумм"
              auto-grow
              solo
              hide-details
              rows='1'
              disabled
              outlined
              :class="{'l-font': $vuetify.breakpoint. smAndDown, 'b-font': $vuetify.breakpoint. mdAndUp}"
              class="centered-input px-2"
              style="text-align: center; color: black; line-height: 2rem"
            ></v-textarea>
          </v-flex>
          <v-flex>
            <!-- Посчитали -->
            <v-layout xs12 class="pt-5 flexcenter mx-1"> 
              <v-flex xs3>
                <v-text-field
                value="MD5"
                single-line
                solo
                hide-details
                disabled
                flat
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                class="px-2 blacktext"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 @click.stop="opendialog('MD5', md5value)">
                <v-text-field
                :value="md5value"
                single-line
                solo
                hide-details
                readonly
                outlined
                class="px-2 blacktext truncated"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn tile large icon class="icon-btn"
                  v-clipboard="md5value"
                  v-clipboard:success="clipboardSuccessHandler"
                  v-clipboard:error="clipboardErrorHandler"
                >
                  <img src="@/assets/copypaste.png" alt="" style="width:90%">
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout xs12 class="flexcenter mx-1"> 
              <v-flex xs3>
                <v-text-field
                value="SHA-3"
                single-line
                solo
                hide-details
                disabled
                flat
                class="px-2 blacktext"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 @click.stop="opendialog('SHA-3', sha3value)">
                <v-text-field
                :value="sha3value"
                single-line
                solo
                hide-details
                readonly
                outlined
                class="px-2 blacktext truncated"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn tile large icon class="icon-btn"
                  v-clipboard="sha3value"
                  v-clipboard:success="clipboardSuccessHandler"
                  v-clipboard:error="clipboardErrorHandler"
                >
                  <!-- <v-icon>mdi-vuetify</v-icon> -->
                  <img src="@/assets/copypaste.png" alt="" style="width:90%">
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout xs12 class="flexcenter mx-1"> 
              <v-flex xs3>
                <v-text-field
                value="SHA512"
                single-line
                solo
                hide-details
                disabled
                flat
                class="px-2 blacktext"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 @click.stop="opendialog('SHA512', sha512value)">
                <v-text-field
                :value="sha512value"
                single-line
                solo
                hide-details
                readonly
                outlined
                class="px-2 blacktext truncated"
                :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn tile large icon class="icon-btn"
                  v-clipboard="sha512value"
                  v-clipboard:success="clipboardSuccessHandler"
                  v-clipboard:error="clipboardErrorHandler"
                  >
                  <!-- <v-icon>mdi-vuetify</v-icon> -->
                  <img src="@/assets/copypaste.png" alt="" style="width:90%">
                </v-btn>
              </v-flex>
            </v-layout>

          </v-flex>

        </v-card>
      </v-flex>
    </v-layout>

    <v-layout xs12 class="pt-5">
      <v-flex xs12>
        <v-card class="mx-5: $vuetify.breakpoint. mdAndUp">
          <v-flex xs12>
              <v-textarea
                :value="headerText"
                auto-grow
                solo
                hide-details
                rows='1'
                disabled
                outlined
                class="centered-input px-2"
                :class="{'l-font': $vuetify.breakpoint. smAndDown, 'b-font': $vuetify.breakpoint. mdAndUp}"
                style="text-align: center; color: black"
              ></v-textarea>
            </v-flex>
            <v-flex v-if="registered">
              <v-layout xs12 class="pt-5 flexcenter mx-1 py-1"> 
                <v-flex xs4>
                  <v-text-field
                  value="ID-файла"
                  single-line
                  solo
                  hide-details
                  disabled
                  flat
                  class="px-2 blacktext"
                  :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 @click.stop="opendialog('ID-файла', documentID)">
                  <v-text-field
                  :value="documentID"
                  single-line
                  solo
                  hide-details
                  disabled
                  outlined
                  class="px-2 blacktext truncated"
                  :class="{ 'greenbg': foundedDoc, 'redbg': !foundedDoc, 'l-font': $vuetify.breakpoint. smAndDown }"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout xs12 class="flexcenter mx-1 py-1"> 
                <v-flex xs4>
                  <v-text-field
                  value="Система-регистратор"
                  single-line
                  solo
                  hide-details
                  disabled
                  flat
                  class="px-2 blacktext"
                  :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 @click.stop="opendialog('Система-регистратор', registrator)">
                  <v-text-field
                  :value="registrator"
                  single-line
                  solo
                  hide-details
                  disabled
                  outlined
                  class="px-2 blacktext truncated"
                  :class="{ 'greenbg': foundedDoc, 'redbg': !foundedDoc, 'l-font': $vuetify.breakpoint. smAndDown }"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-else-if="requested">
              <v-layout xs12 class="pt-5 flexcenter mx-1 py-1"> 
                <v-flex>
                  <v-text-field
                  :value="paymentStatusText"
                  single-line
                  solo
                  hide-details
                  disabled
                  flat
                  class="px-2 blacktext"
                  :class="{'l-font': $vuetify.breakpoint. smAndDown}"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-else class="py-5 flexcenter">
              <v-progress-circular
                align-self-center
                :size="80"
                :width="7"
                color="grey"
                indeterminate
                style="margin: 4rem auto"
              ></v-progress-circular>          
            </v-flex>        
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout xs12 class="pt-5">
      <v-row>
        <v-col cols="6">
          <v-text-field
            hide-details
            label="E-mail для получения отчета о регистрации"
            auto-grow
            outlined
            readonly
            rows="1"
            row-height="15"
            v-model="email"
        ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-btn block color="success" class="mt-5" :disabled="!registered" @click="downloadReport">
            <span class="text-wrap">
              Скачать отчет о регистрации
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-layout>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{ dialigHeader }}</v-card-title>

        <v-card-text style="word-break: break-word;">
          {{ dialogText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
      <v-btn text icon @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
  
</template>

<script>
import { httpClient } from '../infrastructure/api/config';
import { usePathFromBaseURI } from '../infrastructure/api/endpoints';

const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export default {
  data() {
    return {
      docId: null,

      calculated: false,
      md5value: '',
      sha3value: '',
      sha512value: '',
      documentID:'',
      registrator:'',
      status:'',
      dialog: false,
      dialigHeader: '',
      dialogText: '',
      typeOfFile: '',
      fileName: '',
      snackbarText: '',
      snackbar: false,
      timeout: 2000,
      snackbarColor: undefined,
      foundedDoc: false,
      headerText: 'Результат регистрации в системе AVISHASH',
      registered: false,
      toRegister: false,
      email: null,
      emailIsValid: false,
      rules: {
        required: v => !!v || "Обязательное поле",
        email: v => patternEmail.test(v) || "Неверный адрес E-mail"
      },
      orderNumber: null,
      requested: false,
      paymentStatusText: 'Обработка платежа...',
      reportURL: null

    }
  },
  computed: {
  },
  methods: {
    opendialog(header, text) {
      this.dialigHeader = header
      this.dialogText = text
      this.dialog = true
    },
    clipboardSuccessHandler () {
      this.snackbarColor = undefined
      this.snackbarText = 'Скопировано'
      this.snackbar = true
    },

    clipboardErrorHandler () {
      this.snackbarColor = 'error'
      this.snackbarText = 'Ошибка копирования'
      this.snackbar = true
    },
    async sleep() {
       return new Promise(resolve => {
        setTimeout(resolve, 10000);
      });
    },
    async getData(docId) {
      let transaction = null
      this.requested = true
      try {
        const endpoint = usePathFromBaseURI('api', 'payments', `${docId}`)
        transaction = await httpClient.get(endpoint.href)

        // transaction = await axios.get(`https://avishash-functions.azurewebsites.net/api/getTransaction?code=DjyKy0w6p34nh/SDQqcn4zHVTpCGdEXOrBI7E9aREPYC0h7xPQdKqQ==&id=${docId}`)
        if (transaction.data.status === 'reported') {
          this.registered = true
          this.documentID = transaction.data.documentId
          this.registrator = transaction.data.serviceName
          this.email = transaction.data.email
          this.md5value = transaction.data.mD5Hash
          this.sha3value = transaction.data.shA3512Hash
          this.sha512value = transaction.data.shA512Hash
          this.foundedDoc = true
          this.reportURL = transaction.data.reportURL || null
        } else if(transaction.data.status === 'rejected') {
          this.paymentStatusText = 'Ошибка платежа.'
        } else {
          this.documentID = transaction.data.documentId
          this.registrator = transaction.data.serviceName
          this.email = transaction.data.email
          this.md5value = transaction.data.mD5Hash
          this.sha3value = transaction.data.shA3512Hash
          this.sha512value = transaction.data.shA512Hash
          this.foundedDoc = true

          await this.sleep()
          await this.getData(docId)
        }
      }catch(err){
        this.requested = false
        this.snackbarColor = 'error'
        this.snackbarText = err.response && err.response.status && err.response.status === 404 ? 'Транзакция не найдена': 'Ошибка получения транзакции'
        this.snackbar = true
      }
    },
    downloadReport() {
      if (this.reportURL) {
        window.open(this.reportURL, "_blank")
      }
    }

  },
  async mounted() {
    this.docId = this.$route.params.id
    await this.getData(this.docId)
  }
}
</script>

<style>
  .centered-input input {
    text-align: center;
    color:black !important
  }
  .centered-input textarea {
    text-align: center;
    color:black !important;
    margin:1rem auto;
    line-height: 100%;
  }
  .icon-btn .v-btn__content {
    width: 90%;
  }
  .flexcenter {
    justify-content: center; align-items: center; display: flex;
  }

  .blacktext input {
    color: black !important;
  }

  .greenbg fieldset{
    background-color: #c5f3c5a8
  }
  .redbg fieldset{
    background-color: #ff673c96
  }

  .l-font textarea{
    font-size: 0.8rem;
  }
  .b-font textarea{
    font-size: 1.5vw;
  }
  .l-font input{
    font-size: 0.8rem;
  }
  .b-font input{
    font-size: 1.5vw;
  }
  .embedContainer {
    position: relative;
  }
  .text-block {
    position: absolute;
    bottom: 0.1rem;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    background-color: #2d2d2dc7;
    color: #fafafa;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .truncated input {
    text-overflow: ellipsis;
  }
  #submitbutton .v-btn__content {
    width: fit-content;
  }

</style>